/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Cap_Spaces_Create_Data_DescInputs */



/**
* | output |
* | --- |
* | "Allows creating knowledge (data) spaces for documents and retrieval." |
*
* @param {Rights_Cap_Spaces_Create_Data_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_cap_spaces_create_data_desc = /** @type {((inputs?: Rights_Cap_Spaces_Create_Data_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Cap_Spaces_Create_Data_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erlaubt das Erstellen von Wissensräumen (Data-Spaces) für Dokumente und Retrieval.")
	return /** @type {LocalizedString} */ ("Allows creating knowledge (data) spaces for documents and retrieval.")
});